import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";

const columnHelper = createColumnHelper<any>();

const getTerminalActivityLogColumns = () =>
  [
    columnHelper.accessor("changedAt", {
      id: "changedAt",
      header: "Timestamp",
      cell: (cellProps) => {
        const value = cellProps.getValue();
        const date = new Date(value);
        const formattedParts = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const formattedDate = date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
        });

        return (
          <div>
            <span>{formattedDate} </span>
            <span className="xgs-activitylog__formatedtime">
              {formattedParts}
            </span>
          </div>
        );
      },
      enableColumnFilter: false,
      size: 170,
    }),
    columnHelper.accessor("terminalName", {
      id: "terminalName",
      header: "Terminal",
      cell: (cellProps) => {
        const row = cellProps.row.original;
        return (
          <div className="row">
            {row.terminalName}
            {(row?.terminalNumber !== null && row?.terminalNumber !== undefined) ? (
              <span className="xgs-activitylog__formatedtime">
                {row?.terminalNumber}
              </span>) : ""}
          </div>
        )
      },
      enableColumnFilter: false,
      size: 200,
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: "Action",
      cell: (cellProps) => {
        const row = cellProps.row.original;
        const action = row?.action;

        const actionColorMap: Record<string, TagColor> = {
          UPDATE: TagColor.ORANGE,
          CREATE: TagColor.GREEN,
          APPROVE: TagColor.GREEN,
          DELETE: TagColor.RED,
          REJECT: TagColor.RED,
        };

        const tagColor = actionColorMap[action] || TagColor.GREY;

        return <Tag mods={{ color: tagColor }}>{action}</Tag>;

      },
      enableColumnFilter: false,
      size: 80,
    }),
    columnHelper.accessor("modifiedBy", {
      id: "modifiedBy",
      header: "Changed By",
      enableColumnFilter: false,
      size: 170,
    }),
    columnHelper.accessor("changeDescription", {
      id: "changeDescription",
      header: "Description",
      enableColumnFilter: false,
      size: 270
    })
  ];

export default getTerminalActivityLogColumns;